var exports = {
  "S": "x234b8571--88a13f--image",
};

module.exports = exports;
